import { get } from 'lodash';
import withRoles from 'hoc/withRoles';
import { PropTypes } from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { reduxForm } from 'redux-form';
import { phoneField, requiredField, validateForm } from '@zipdrug/ui';
import { useNavigate } from 'react-router-dom';
import withPhoneMutation from '../hoc/withPhoneMutation';
import { setWorkstationPhoneId } from '../redux/queryReducer';
import CreateWorkstationPhonePage from './CreateWorkstationPhonePage';

const ERROR_MESSAGES = {
  invalidPhone: 'is invalid',
  required: 'is required.',
};

const CREATE_WORKSTATION_PHONE_SCHEMA = {
  label: requiredField,
  number: {
    ...phoneField,
    required: true,
  },
};

const validate = values => validateForm(values, CREATE_WORKSTATION_PHONE_SCHEMA, ERROR_MESSAGES);
const ReduxCreateWorkstationPhonePage = reduxForm({
  form: 'createWorkstationPhone',
  validate,
})(CreateWorkstationPhonePage);

class CreateWorkstationPhonePageContainer extends Component {
  static propTypes = {
    navigate: PropTypes.func.isRequired,
    onAssignToWorkstation: PropTypes.func,
    mutateCreatePhone: PropTypes.func,
    isPbsTeam: PropTypes.bool,
    isPharmacyTeam: PropTypes.bool,
  };

  handleClickBack = () => this.props.navigate('/register-phone');

  handleSubmit = async values =>
    this.props.mutateCreatePhone({ ...values }).then(({ data }) => {
      const createdPhoneId = get(data, 'createPhone.data.id');

      this.props.onAssignToWorkstation(createdPhoneId);
      if (this.props?.isPbsTeam) {
        this.props.navigate('/leadlist', { replace: true });
      } else if (this.props?.isPharmacyTeam) {
        this.props.navigate('/settings/pharmacylist', { replace: true });
      } else {
        this.props.navigate('/members', { replace: true });
      }
    });

  render = () => (
    <ReduxCreateWorkstationPhonePage
      onClickBack={this.handleClickBack}
      onSubmit={this.handleSubmit}
    />
  );
}

const mapDispatchToProps = dispatch => ({
  onAssignToWorkstation(phoneId) {
    dispatch(setWorkstationPhoneId({ phoneId }));
  },
});

const CreateWorkstationPhonePageContainerWithNavigate = props => {
  const navigate = useNavigate();
  return <CreateWorkstationPhonePageContainer {...props} navigate={navigate} />;
};

export default compose(
  withRoles,
  withPhoneMutation,
  connect(null, mapDispatchToProps),
)(CreateWorkstationPhonePageContainerWithNavigate);